module.exports = __webpack_public_path__ + "prod/1.42.2/img/arrow-top.90fc7870.png";